import { gql } from '@apollo/client';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  BROKER_ID_NAME_FIELDS,
  COUNTRY_FIELDS,
  PROPERTY_MAIN_FIELDS,
  PAGINATION_FIELDS,
} from 'graphql/common/fragments';

export const SALE_PAGINATION_DATA_FRAGMENT = gql`
  fragment salePaginationData on SaleSearchResponse {
    ${PAGINATION_FIELDS}
  }
`;

export const SALE_BASIC_DATA_FRAGMENT = gql`
  fragment saleBasicData on Sale {
    id
    dealId
    buyers {
      ${ID_NAME_FIELDS}
    }
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
    buyersBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
    createdAt
    updatedAt
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
    capRate
    currencyCode
    date
    dateOnMarket
    interestPercent
    isConvertedSale
    measurementSystem
    occupancy
    partOfPortfolio
    numberOfBuildings
    partialInvVol
    price
    pricePerSF
    pricePerUnit
    pricePerSFRaw
    sf
    squareMeters
    floor
    suite
    comments
    type {
      ${ID_NAME_FIELDS}
    }
    property {
      ${PROPERTY_MAIN_FIELDS}
      convertedFromPropertyId
      status {
        ${ID_NAME_FIELDS}
      }
      propertyCountry {
        ${COUNTRY_FIELDS}
      }
      propertyType {
        ${ID_NAME_FIELDS}
      }
      propertySubtype {
        ${ID_NAME_FIELDS}
      }
      propertySubtypeDetail {
        ${ID_NAME_FIELDS}
      }
      propertyClass {
        ${ID_NAME_FIELDS}
      }
      market {
        ${ID_NAME_FIELDS}
      }
      submarket {
        ${ID_NAME_FIELDS}
      }
      micromarket {
        ${ID_NAME_FIELDS}
      }
    }
    sellers {
      ${ID_NAME_FIELDS}
    }
    sellersBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
    units
    tenureType
    longLeaseHoldExpiry
    waultToBreakDate
    waultToExpiry
    totalRent
    vacantPossession
  }
`;

export const SALE_BASIC_DATA_NO_IMAGES_FRAGMENT = gql`
  fragment saleBasicDataNoImages on Sale {
    id
    buyers {
      ${ID_NAME_FIELDS}
    }
    buyersBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
    createdAt
    updatedAt
    country {
      ${COUNTRY_FIELDS}
    }
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
    capRate
    currencyCode
    date
    dateOnMarket
    interestPercent
    measurementSystem
    occupancy
    partOfPortfolio
    numberOfBuildings
    partialInvVol
    price
    pricePerSF
    pricePerUnit
    pricePerSFRaw
    sf
    squareMeters
    floor
    suite
    totalRent
    type {
      ${ID_NAME_FIELDS}
    }
    property {
      ${PROPERTY_MAIN_FIELDS}
      propertyCountry {
        ${COUNTRY_FIELDS}
      }
      locationType {
        ${ID_NAME_FIELDS}
      }
    }
    sellers {
      ${ID_NAME_FIELDS}
    }
    sellersBrokers {
      ${BROKER_ID_NAME_FIELDS}
    }
  }
`;
